import { render, staticRenderFns } from "./KisDepartmentEditDialog.vue?vue&type=template&id=bf92184e"
import script from "./KisDepartmentEditDialog.js?vue&type=script&lang=js&external"
export * from "./KisDepartmentEditDialog.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports